import Api from "../../axios"

export const getShortDayCount =async()=>{
    return await Api.get('/short_days_count')
}